function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import Log from '@deephaven/log';
import { PromiseUtils } from '@deephaven/utils';
import "./FileListItemEditor.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('FileListItemEditor');
var DEFAULT_VALIDATE = () => Promise.resolve();
export function FileListItemEditor(_ref) {
  var item = _ref.item,
    onCancel = _ref.onCancel,
    onSubmit = _ref.onSubmit,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? DEFAULT_VALIDATE : _ref$validate;
  var input = useRef(null);
  var _useState = useState(item.basename),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    validationError = _useState4[0],
    setValidationError = _useState4[1];
  var _useState5 = useState(Promise.resolve()),
    _useState6 = _slicedToArray(_useState5, 2),
    validationPromise = _useState6[0],
    setValidationPromise = _useState6[1];
  var focus = useCallback(() => {
    var _input$current;
    (_input$current = input.current) === null || _input$current === void 0 || _input$current.focus();
    // Select the proper range based on the type...
  }, [input]);
  var stopPropagation = useCallback(e => e.stopPropagation(), []);
  var validateAndSubmit = useCallback(() => {
    validationPromise.then(() => {
      onSubmit(value);
    }).catch(e => log.info('Unable to validate name', e));
  }, [onSubmit, value, validationPromise]);
  useEffect(function validateValueAndSetPromise() {
    var validatePromise = PromiseUtils.makeCancelable(validate(value));
    validatePromise.then(() => setValidationError(undefined)).catch(e => {
      if (!PromiseUtils.isCanceled(e)) {
        setValidationError(e);
      }
    });
    setValidationPromise(validatePromise);
    return () => validatePromise.cancel();
  }, [validate, value]);
  useEffect(function selectRange() {
    focus();
  }, [focus]);
  var handleBlur = useCallback(() => {
    log.debug2('handleBlur');
    validateAndSubmit();
  }, [validateAndSubmit]);
  var handleChange = useCallback(e => {
    var newValue = e.target.value;
    setValue(newValue);
  }, []);
  var handleKeyDown = useCallback(e => {
    e.stopPropagation();
    var key = e.key;
    switch (key) {
      case 'Enter':
        {
          validateAndSubmit();
          break;
        }
      case 'Escape':
        {
          onCancel();
          break;
        }
      default:
    }
  }, [onCancel, validateAndSubmit]);
  return /*#__PURE__*/_jsxs("div", {
    className: "file-list-item-editor",
    children: [/*#__PURE__*/_jsx("input", {
      type: "text",
      className: classNames('form-control file-list-item-editor-input', {
        'is-invalid': validationError
      }),
      value: value,
      ref: input,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      onChange: handleChange,
      onClick: stopPropagation,
      onDoubleClick: stopPropagation,
      onMouseDown: stopPropagation
    }), validationError && /*#__PURE__*/_jsx("div", {
      className: "invalid-feedback",
      children: "".concat(validationError)
    })]
  });
}
export default FileListItemEditor;
//# sourceMappingURL=FileListItemEditor.js.map